// extracted by mini-css-extract-plugin
export var heightBox = "ResponsiveContainer-module--heightBox--KsMI7";
export var responsiveContainer = "ResponsiveContainer-module--responsiveContainer--4bu9R";